import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import LeadCaptureForm from "@/components/LeadCaptureForm";

export default function LeadCaptureSection() {
  return (
    <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="lead-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Get Your Free <span className="text-[#D4AF37]">Guide</span>
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">
            No-BS guides to help you buy or sell with confidence.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="card-dark p-8 md:p-10 border-[#D4AF37]/30 hover:border-[#D4AF37]/60 transition-colors">
            <LeadCaptureForm
              type="buyer"
              title="Buyer's Guide"
              subtitle="Everything you need to know before buying. No fluff, just facts."
            />
          </div>
          <div className="card-dark p-8 md:p-10 border-[#D4AF37]/30 hover:border-[#D4AF37]/60 transition-colors">
            <LeadCaptureForm
              type="seller"
              title="Seller's Guide"
              subtitle="Learn exactly how to sell for top dollar. Straight talk, real strategy."
            />
          </div>
        </div>
      </div>
    </section>
  );
}
